import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { WorkClearance } from './work-order'

@Directive({
  selector: '[appWorkClearanceSelect]',
})
export class WorkClearanceSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)
  private enumTranslationService = inject(ElderEnumTranslationService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.displayProperty = 'displayValue'

    this.select.dataSource = this.enumTranslationService.enumDataSource(
      WorkClearance,
      'WorkClearance',
      false
    )
  }
}
